export default __webpack_public_path__ + "static/04-f6273b9aa2e4c339702d82dce7472479.jpg";